'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$() {
  this.aMf = null;
  this.aMg = false;
  this.aMh = null;
  this.aMi = false;
  this.aMb = null;
  this.aMc = false;
  this.aMd = null;
  this.aMe = false;
  this.aMj = null;
  this.aMk = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$.prototype = $p;
$p.aA = (function() {
  if ((!this.aMg)) {
    this.aMf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate$Newtype$$anon$2(this);
    this.aMg = true;
  }
  return this.aMf;
});
$p.t1 = (function() {
  if ((!this.aMi)) {
    this.aMh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate$Newtype$$anon$4(this);
    this.aMi = true;
  }
  return this.aMh;
});
$p.jh = (function() {
  if ((!this.aMc)) {
    this.aMb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var e$proxy2 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$().iu(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_FrameworkDate$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_FrameworkPlatform$().ag0())));
      matchResult22: {
        var $x_1;
        if ((e$proxy2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
          throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy2.bj) + ")"));
        }
        if ((e$proxy2 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
          var ev$2 = e$proxy2.aI;
          var $x_1 = ((ev$2 === null) ? null : ev$2.cs);
          break matchResult22;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy2);
      }
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate($x_1);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aMc = true;
  }
  return this.aMb;
});
$p.W6 = (function() {
  if ((!this.aMe)) {
    this.aMd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Issue Date";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aMe = true;
  }
  return this.aMd;
});
$p.aY = (function() {
  if ((!this.aMk)) {
    this.aMj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().Cc;
    this.aMk = true;
  }
  return this.aMj;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$, "app.data.data_point_types$package$IssueDate$", ({
  G0: 1,
  B: 1,
  C: 1,
  f0: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$IssueDate$ };
//# sourceMappingURL=app.data.data_point_types$package$-Issue-Date$.js.map
